import { useState, useEffect } from 'react';

/**
 * Get language from localStorage (single source of truth)
 */
const getLanguage = () => {
  return localStorage.getItem('preferredLanguage') || 'nl';
};

/**
 * Custom hook for reactive language code
 * Returns the current language code and updates when language changes
 *
 * Usage:
 * const lang = useLanguage();
 * // lang will be 'nl', 'en', 'fr', etc.
 *
 * @returns {string} Current language code
 */
const useLanguage = () => {
  const [currentLanguage, setCurrentLanguage] = useState(getLanguage);

  useEffect(() => {
    // Listen for language changes within this tab
    const handleLanguageChange = () => {
      setCurrentLanguage(getLanguage());
    };

    // Listen for changes from other tabs
    const handleStorage = (e) => {
      if (e.key === 'preferredLanguage') {
        setCurrentLanguage(e.newValue || 'nl');
      }
    };

    window.addEventListener('languageChange', handleLanguageChange);
    window.addEventListener('storage', handleStorage);

    return () => {
      window.removeEventListener('languageChange', handleLanguageChange);
      window.removeEventListener('storage', handleStorage);
    };
  }, []);

  return currentLanguage;
};

export default useLanguage;
